// src/context/AuthContext.js
import React, { createContext, useContext } from "react";
import { useAuth } from "hooks";
import { useOutlet } from "react-router";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const auth = useAuth();
  const outlet = useOutlet();
  return <AuthContext.Provider value={auth}>{outlet}</AuthContext.Provider>;
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};
